export const products = state => {
  return state.products;
};

export const noSectorProducts = state => {
  return state.noSectorProducts;
};

export const sectors = state => {
  return state.sectors;
};

export const sectorMap = state => {
  return state.sectorMap;
};

export const separateProducts = state => {
  return state.separateProducts;
};

export const maxCartCoupon = state => {
  return state.maxCartCoupon;
};

export const selectedSector = state => {
  return state.selectedSector;
};
export const tempSelectedSector = state => {
  return state.tempSelectedSector;
};
export const cupomMessage = state => {
  return state.cupomMessage;
};

export const cartProducts = state => {
  var sumCart = [];

  if (state.selectedSector) {
    var selectedSectorCart = state.selectedSector.products.filter(type => {
      return type.quantidade > 0;
    });
    let sectorCartArr = [];
    sectorCartArr.push(selectedSectorCart);
    sectorCartArr.forEach(el => sumCart.push(el));
  }
  if (state.noSectorProducts) {
    let nosectorCart = state.noSectorProducts.map(product => {
      const type = product.filter(type => {
        return type.quantidade > 0;
      });
      return type;
    });
    nosectorCart = nosectorCart.filter(types => types.length > 0);
    nosectorCart.forEach(sl => sumCart.push(sl));
  }
  return sumCart.filter(types => types.length > 0);
};

export const cupomCode = state => {
  return state.cupomCode;
};
export const selectedInfo = state => {
  return state.selectedInfo;
};

export const isValidCupomCode = state => {
  return state.isValidCupomCode;
};

export const hasCupom = state => {
  return state.hasCupom;
};

export const isCupomTracking = state => {
  return state.isCupomTracking;
};

export const isSpecialCupom = state => {
  return state.isSpecialCupom;
};

export const isCupomCard = state => {
  return state.isCupomCard;
};

export const saleUninitiated = state => {
  return state.saleUninitiated;
};

export const cupomData = state => {
  return state.cupomData;
};

export const productsNoGroup = state => {
  return state.productsNoGroup;
};

export const productsAll = state => {
  return state.productsAll;
};

export const showQueue = state => {
  return state.showQueue;
};

export const passedQueue = state => {
  return state.passedQueue;
};

export const positionQueue = state => {
  return state.positionQueue;
};

export const messageQueue = state => {
  return state.messageQueue;
};

export const ticketCodeUrl = state => {
  return state.ticketCodeUrl;
};

export const productsCodeUrl = state => {
  return state.productsCodeUrl;
};
